var _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaf2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "134.2698 187.739 176.026 176.026",
    width: "176.026px",
    height: "176.026px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.7071070075035095, -0.7071070075035095, 0.7071070075035095, -0.7071070075035095, 157.71780630525654, 273.3035319045712)",
    id: "object-6"
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: -55.558,
    y1: 72.624,
    x2: -55.558,
    y2: 101.624,
    stroke: "#2e7d32",
    strokeWidth: 3,
    id: "object-0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M -45.905 26.284 C -46.294 23.074 -31.008 -21.307 -2.006 6.554 C 20.92 28.578 1.031 83.115 -43.254 111.43 C -86.367 82.719 -122.82 32.076 -87.968 7.247 C -53.719 -17.154 -45.516 29.494 -45.905 26.284 Z",
    fill: "#419646",
    stroke: "#2e7d32",
    strokeWidth: 3,
    style: {
      strokeWidth: 3,
      transformOrigin: "-43.255px 43.138px"
    },
    transform: "matrix(0.999783, 0.020846, -0.020846, 0.999783, 0, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -45.287,
    y1: -24.629,
    x2: -45.287,
    y2: 110.942,
    stroke: "#2e7d32",
    strokeWidth: 2,
    style: {
      transformBox: "fill-box",
      transformOrigin: "0% 43.8784%"
    },
    id: "object-1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -44.951,
    y1: 56.521,
    x2: -74.951,
    y2: 86.521,
    stroke: "#2e7d32",
    strokeWidth: 1.5,
    style: {
      transformBox: "fill-box",
      transformOrigin: "50% 50%"
    },
    id: "object-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -46.369,
    y1: 25.515,
    x2: -1.034,
    y2: 64.5,
    stroke: "#2e7d32",
    strokeWidth: 1.5,
    style: {
      transformBox: "fill-box",
      transformOrigin: "50% 50%"
    },
    id: "object-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -45.897,
    y1: 26.933,
    x2: -87.922,
    y2: 67.81,
    stroke: "#2e7d32",
    strokeWidth: 1.5,
    style: {},
    id: "object-4"
  }), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: -45.187,
    y1: 56.285,
    x2: -15.187,
    y2: 86.285,
    stroke: "#2e7d32",
    strokeWidth: 1.5,
    id: "object-5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf2);
export default __webpack_public_path__ + "static/media/leaf2.1d3fee1debc8f9de7d433e3ef276fa6e.svg";
export { ForwardRef as ReactComponent };